import { render } from "./FreeTrade.vue?vue&type=template&id=43a3baf8&ts=true"
import script from "./FreeTrade.vue?vue&type=script&lang=ts"
export * from "./FreeTrade.vue?vue&type=script&lang=ts"

import "./FreeTrade.vue?vue&type=style&index=0&id=43a3baf8&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__